/* RS Motor de busca (25/09/2026)
   Base única da busca da loja: catálogo vivo (/products.json) + base de aplicação da planilha
   da RS (assets/rs-aplicacoes.json, indexada por código/SKU).
   Existe porque a busca nativa do Shopify só casa o começo do token (quem digita "2933" não
   acha o RS2933), esconde produto indisponível e completa a lista com aproximações.
   Usado pela barra do topo e pela página de resultados. O buscador por veículo da home tem
   a sua própria cópia da junção, em sections/rs-buscador.liquid. */
window.RSMotor = (function () {
  var raiz = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var CAT = null, carga = null;
  var CHAVE = 'rs-motor-v2';

  function norm(t) {
    return String(t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function paginas(n, acc) {
    return fetch(raiz + 'products.json?limit=250&page=' + n)
      .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.json(); })
      .then(function (d) {
        var ps = d.products || [];
        acc = acc.concat(ps);
        return ps.length === 250 ? paginas(n + 1, acc) : acc;
      });
  }

  function montar(vivos, apl) {
    var MA = apl.marcas || [], MD = apl.modelos || [], MT = apl.motores || [], IT = apl.itens || {};
    return vivos.map(function (p) {
      var vs = p.variants || [];
      var skus = vs.map(function (x) { return x.sku; }).filter(Boolean);
      var precos = vs.map(function (x) { return parseFloat(x.price); }).filter(function (n) { return !isNaN(n); });
      var d = null;
      for (var i = 0; i < skus.length && !d; i++) d = IT[String(skus[i]).toUpperCase()] || null;
      d = d || {};
      var aps = (d.a || []).map(function (a) {
        return [MA[a[0]] || '', MD[a[1]] || '', a[2] || '', MT[a[3]] || ''].join(' ').trim();
      });
      var montadoras = [];
      (d.a || []).forEach(function (a) {
        var m = MA[a[0]] || '';
        if (m && montadoras.indexOf(m) < 0) montadoras.push(m);
      });
      var nt = norm(p.title), nty = norm(p.product_type || '');
      /* o product_type cadastrado mistura categoria de veículo com linha (Carros, Motos,
         FT Air Filter Cônico Street...), então as facetas saem do título, que é consistente */
      var formato = /conic/.test(nt) || /conic/.test(nty) ? 'Cônico'
        : /respiro/.test(nt) ? 'Respiro'
        : /carburador/.test(nt) ? 'Carburador'
        : /inbox/.test(nt) ? 'Inbox'
        : (nty.indexOf('acessorio') >= 0 ? 'Acessório' : '');
      var medida = null, mb = p.title.toUpperCase().match(/(\d+(?:[,.]\d+)?)\s*POL/), mh = p.title.toUpperCase().match(/(\d{2,3})\s*MM/);
      if (mb || mh) medida = [mb ? mb[1].replace('.', ',') : '', mh ? mh[1] : ''];
      return {
        fo: formato,
        li: /fueltech/.test(nt) ? 'FuelTech' : (/ultra/.test(nt) ? 'Ultra' : ''),
        us: /racing/.test(nt) ? 'Racing' : (/street/.test(nt) ? 'Street' : ''),
        cor: /vermelh/.test(nt) ? 'Vermelho' : (/azul/.test(nt) ? 'Azul' : (/cinza/.test(nt) ? 'Cinza' : '')),
        mo: montadoras,
        co: medida,
        h: p.handle,
        t: p.title,
        p: precos.length ? Math.min.apply(null, precos) : 0,
        img: (p.images && p.images[0]) ? p.images[0].src : '',
        sku: skus,
        ty: p.product_type || '',
        eq: d.e || [],
        ap: aps,
        nt: norm(p.title),
        nap: norm(aps.join(' ')),
        nsk: norm(skus.join(' ')),
        neq: norm((d.e || []).join(' ')),
        nty: norm(p.product_type || '')
      };
    });
  }

  function doCache() {
    try {
      var s = sessionStorage.getItem(CHAVE);
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }
  function guardar(cat) {
    try { sessionStorage.setItem(CHAVE, JSON.stringify(cat)); } catch (e) { /* cota cheia: segue sem cache */ }
  }

  function carregar() {
    if (CAT) return Promise.resolve(CAT);
    if (carga) return carga;
    var c = doCache();
    if (c && c.length) { CAT = c; return Promise.resolve(CAT); }
    carga = Promise.all([
      paginas(1, []),
      fetch(window.RSMotorAplUrl || (raiz + 'cdn/rs-aplicacoes.json')).then(function (r) { return r.json(); }).catch(function () { return {}; })
    ]).then(function (r) {
      CAT = montar(r[0], r[1] || {});
      guardar(CAT);
      carga = null;
      return CAT;
    }).catch(function (e) { carga = null; throw e; });
    return carga;
  }

  function fuga(t) { return t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function palavraInteira(t, texto) { return new RegExp('(^|[^a-z0-9])' + fuga(t) + '([^a-z0-9]|$)').test(texto); }

  /* pontuação: SKU exato manda mais que título, e título manda mais que aplicação.
     Palavra inteira vale mais que pedaço, senão "gol" casaria em "Golf" com o mesmo peso. */
  function pontos(c, tk) {
    var total = 0;
    for (var i = 0; i < tk.length; i++) {
      var t = tk[i], p = 0;
      if (c.nsk.split(/\s+/).indexOf(t) >= 0) p = 120;
      else if (c.nsk.indexOf(t) >= 0) p = 60;
      else if (c.neq.indexOf(t) >= 0) p = 45;
      else if (palavraInteira(t, c.nt)) p = 40;
      else if (new RegExp('(^|[^a-z0-9])' + fuga(t)).test(c.nt)) p = 25;
      else if (c.nt.indexOf(t) >= 0) p = 18;
      else if (c.nap.indexOf(t) >= 0) p = 10;
      else if (c.nty.indexOf(t) >= 0) p = 6;
      if (!p) return 0; /* todo termo tem que casar em algum campo */
      total += p;
    }
    /* quem tem tudo no próprio nome vem antes de quem casou por pedaço de SKU ou por aplicação */
    if (tk.every(function (t) { return palavraInteira(t, c.nt); })) total += 45;
    else if (tk.every(function (t) { return c.nt.indexOf(t) >= 0; })) total += 20;
    if (c.nt.indexOf(tk.join(' ')) >= 0) total += 25;
    return total;
  }

  function buscar(texto, limite) {
    var v = norm(texto).trim();
    if (!v) return [];
    var tk = v.split(/\s+/).filter(Boolean);
    var r = [];
    (CAT || []).forEach(function (c) {
      var s = pontos(c, tk);
      if (s) r.push({ c: c, s: s });
    });
    r.sort(function (a, b) { return b.s - a.s || a.c.t.localeCompare(b.c.t, 'pt-BR'); });
    var saida = r.map(function (x) { return x.c; });
    return limite ? saida.slice(0, limite) : saida;
  }

  return {
    carregar: carregar,
    buscar: function (texto, limite) { return carregar().then(function () { return buscar(texto, limite); }); },
    buscarJa: buscar,
    get catalogo() { return CAT; }
  };
})();
